(function(angular, _) {
    /**
     * @ngdoc component
     * @name GridTableConfigController
     * @description List table component controller
     */
    class GridTableConfigController {
        static get $inject() {
            return ['$injector'];
        }

        constructor($injector) {
            this.$q = $injector.get('$q');
            this.wtModal = $injector.get('wtModal');
            this.trackingService = $injector.get('trackingService');

            this.settingsModalOpened = false;

            this.columnsList = [];
        }

        $onChanges(changelist) {
            if (changelist.columns) {
                this.columnsList = _.concat([], changelist.columns.currentValue);
            }
        }

        openSettingsModal() {
            if (this.settingsModalOpened) {
                return this.$q.reject(new Error('Grid settings modal already opened'));
            }

            if (_.isFunction(this.onOpenSettingsModal)) {
                this.onOpenSettingsModal();
            }

            this.settingsModalOpened = true;

            return this.wtModal.show({
                title: 'GRID_TABLE.COLUMN_SETTINGS',
                template: 'src/grid-table/components/grid-table-config/grid-table-config.modal.html',
                controller: 'GridTableModalController',
                controllerAs: '$ctrl',
                size: 'sm',
                resolve: {
                    columns: () => this.columnsList
                }
            }).result
                .then((columns) => {
                    return this.onColumnsChange({columns});
                }, ()=>{
                    if (_.isFunction(this.onCancelSettingsModal)) {
                        this.onCancelSettingsModal();
                    }
                })
                .finally(() => {
                    this.settingsModalOpened = false;
                });
        }
    }

    angular.module('wtUi.wtGridTable').component('gridTableConfig', {
        controller: GridTableConfigController,
        templateUrl: 'src/grid-table/components/grid-table-config/grid-table-config.component.html',
        bindings: {
            /**
             * A flat list of column definitions
             * @type {GridTableColumn[]}
             */
            columns: '<',

            /**
             * Callback to be executed on column change.
             * Provides the updated `columns` as argument
             * @type {Function}
             */
            onColumnsChange: '&',

            /**
             * Callback to be executed on opening the settings modal.
             * @type {Function}
             */
            onOpenSettingsModal: '&?',

            /**
             * Callback to be executed on opening the settings modal.
             * @type {Function}
             */
            onCancelSettingsModal: '&?'
        }
    });
})(window.angular, _);
